// Reprend la typographie du logo : DEMOISELLE en didone condensée, Atypique en script signature.
export const Wordmark = ({ size = "md", className = "" }) => {
  const s = size === "lg" ? { d: "text-[34px]", a: "text-[42px] -mt-[22px]" } : { d: "text-[22px] sm:text-[25px]", a: "text-[30px] sm:text-[34px] -mt-[17px] sm:-mt-[19px]" };
  return (
    <span className={`inline-flex flex-col items-end leading-none text-cream ${className}`} data-testid="wordmark">
      <span className={`font-display font-medium uppercase tracking-[-0.02em] ${s.d}`}>Demoiselle</span>
      <span className={`font-script text-neon ${s.a} pr-[0.15em]`}>Atypique</span>
    </span>
  );
};
